export default {
    title: "Su gerente aprobador es {email}"
}